import countries from 'i18n-iso-countries'
import { getBaseLanguageFromLocaleCode } from '../../../translations/utils'
import type { Country } from './types'

function filterCountriesByName(list: Country[], text: string) {
  // The line below escapes regular expression special characters:
  // [ \ ^ $ . | ? * + ( )
  const escapedText = text.replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&');

  // Create the regular expression with modified value which
  // handles escaping special characters. Without escaping special
  // characters, errors will appear in the console
  const exp = new RegExp(escapedText, 'i');
  return list.filter(o => exp.test(o.name));
}


export function buildHighRiskCountryList(locale: string, filter: string): Country[] {
  const highRiskCountries = [
    'AF', 'BB', 'BF', 'KH', 'KY', 'CD', 'KP', 'GI', 'HT',
    'IR', 'JM', 'JO', 'ML', 'MA', 'MZ', 'MM', 'PA', 'PH',
    'RU', 'SN', 'SS', 'SY', 'TZ', 'TT', 'UG', 'AE', 'VU', 'YE'
  ];

  const list = highRiskCountries.map(code => ({
    countryCode: code,
    name: countries.getName(code, getBaseLanguageFromLocaleCode(locale), { select: 'official' }),
    numericCode: countries.alpha2ToNumeric(code)
  })).sort((a, b) => a.name.localeCompare(b.name));

  return filter ? filterCountriesByName(list, filter) : list;
}